const navigationGeneral = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
    badge: {
      variant: "primary",
      text: "HOME"
    }
  },
  {
    name: "To-Do-List",
    url: "/base/TodoList",
    icon: "icon-grid"
  },
  {
    name: "IT To-Do-List",
    url: "/base/TodoListIT/?showIt=1",
    icon: "icon-grid"
  },
  {
    name: "IT To-Do-Calendar",
    url: "/base/todo-calendar/?showIt=1",
    icon: "icon-grid"
  },
  {
    name: "Accounts Receivables",
    url: "/base/AccountsReceivables",
    icon: "icon-grid"
  },
  {
    name: "Map Overview",
    url: "/base/Map",
    icon: "icon-map"
  }
];
export default navigationGeneral;
